<template>
  <CSidebar
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand to="/dashboard.html">
      <img
        class="c-sidebar-brand-minimized"
        size="custom-size"
        src="/static/img/logo-vds.png"
        height="50"
      />
      <div>
        <center>
          <img
            class="c-sidebar-brand-full"
            size="custom-size"
            src="/static/img/logo-vds.png"
            height="40"
          />
        </center>
        <span v-if="!minimize">QUẢN LÝ TRUYỀN THANH CƠ SỞ</span>
      </div>

      <!--      <CIcon-->
      <!--        class="c-sidebar-brand-full"-->
      <!--        name="logo"-->
      <!--        size="custom-size"-->
      <!--        :height="35"-->
      <!--        viewBox="0 0 556 134"-->
      <!--      />-->
      <!--      <CIcon-->
      <!--        class="c-sidebar-brand-minimized"-->
      <!--        name="logo"-->
      <!--        size="custom-size"-->
      <!--        :height="35"-->
      <!--        viewBox="0 0 110 134"-->
      <!--      />-->
    </CSidebarBrand>
    <CRenderFunction flat :contentToRender="navItems"/>
    <CSidebarMinimizer
      class="c-d-md-down-none"
      @click.native="$store.commit('toggle', 'sidebarMinimize')"
    />
  </CSidebar>
</template>

<script>
import nav from "./_nav";

export default {
  name: "TheSidebar",
  nav,
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  data() {
    return {
      navItems: [],
    };
  },
  methods: {
    setupNavItemByAuthen() {
      let item = nav.items[0];
      let _item = {};
      let childrens = item._children;
      let _childrens = [];
      _item = this.$helper.cloneObject(item);

      if (_item && childrens instanceof Array) {
        for (let children of childrens) {
          let _children = {};
          let childrenPath = children.to;
          let items = children.items;
          let _items = [];
          if (items && items instanceof Array)
            for (let item of items) {
              let itemPath = item.to;
              if (itemPath && this.$isAuthorized(itemPath)) {
                _items.push(this.$helper.cloneObject(item));
              }
            }
          if (
            _items.length !== 0 ||
            (children._name === "CSidebarNavItem" &&
              this.$isAuthorized(childrenPath))
          ) {
            _children = this.$helper.cloneObject(children);
            _children.items = _items;
            _childrens.push(_children);
          }
        }
      }

      _item["_children"] = _childrens;
      this.navItems = [_item];
    },
  },
  created() {
    this.setupNavItemByAuthen();
  },
  mounted() {
  },
};
</script>
